import store from "@redux/store";
import { REGSITER_LEAD_RESPONSE, UPDATE_PARTNER_SELECTED_SLOT, } from "../interface/IRegisterLead";
var RegisterLeadActions = /** @class */ (function () {
    function RegisterLeadActions() {
        this.dispatch = store.dispatch;
    }
    RegisterLeadActions.prototype.setError = function (payload, errorType) { };
    RegisterLeadActions.prototype.hideError = function (errorType) { };
    RegisterLeadActions.prototype.registerLead = function (req) {
        this.dispatch({
            type: REGSITER_LEAD_RESPONSE,
            payload: { registerLead: req },
        });
    };
    RegisterLeadActions.prototype.updatePartnerSlot = function (response) {
        this.dispatch({
            type: UPDATE_PARTNER_SELECTED_SLOT,
            payload: {
                partnerSelectedSlot: response,
            },
        });
    };
    return RegisterLeadActions;
}());
export default RegisterLeadActions;
